<template>
    <div v-if="showStep" class="step-card-wrapper">
        <generic-step-card
            :title="stepTitle"
            :current-step-name="currentStepName"
            :step="step"
            :is-preview="isPreview"
            :is-brief-accepted="isBriefAccepted"
            :is-brief-editable="isBriefEditable"
            :brief="brief"
            :sub-title="subtitle"
        />
    </div>
</template>

<script>
    import GenericStepCard from '../GenericStepCard.vue';
    import { NAME_COMPENSATION } from '../../../../../constants/activation-brief-steps';
    import StepCardViewMixin from '../mixins/StepCardViewMixin';
    import {
        COMMISSION_PAYMENTS,
        CONTRACT_PAYMENTS,
        PAYMENT_TYPE_LABELS
    } from '../../../../../constants/activation-payments';

    export default {
        name: 'CompensationStepCardView',
        components: {
            GenericStepCard
        },
        mixins: [StepCardViewMixin],
        computed: {
            stepName() {
                return NAME_COMPENSATION;
            },
            subtitle() {
                const contract = this.brief[CONTRACT_PAYMENTS]
                    ? PAYMENT_TYPE_LABELS[CONTRACT_PAYMENTS][this.brief?.contract_payments_mode]
                    : '';
                const commission = this.brief[COMMISSION_PAYMENTS] ? PAYMENT_TYPE_LABELS[COMMISSION_PAYMENTS] : '';
                return commission + (contract && commission ? ', ' : '') + contract;
            }
        }
    };
</script>

<style lang="scss" scoped>
    .step-card-wrapper {
        margin-bottom: $g-spacing-5;
    }
</style>
